const cacheKey = 'listing-details-cache';
const languageKey = 'listing-cache-language';

export const getListingDetailsCache = () => {
  return new Promise((resolve) => {
    const cacheString = localStorage.getItem(cacheKey);
    if (cacheString) {
      try {
        const cache = JSON.parse(cacheString);
        resolve(cache);
      } catch (e) {
        resolve({});
      }
    } else {
      resolve({});
    }
  });
};

export const setListingDetailsCache = (cache) => {
  return new Promise((resolve) => {
    try {
      localStorage.setItem(cacheKey, JSON.stringify(cache));
      // Store current language when updating cache
      localStorage.setItem(languageKey, window.freedomeConfig.locale);
    } finally {
      resolve();
    }
  });
};

export const clearListingDetailsCache = () => {
  return new Promise((resolve) => {
    try {
      localStorage.removeItem(cacheKey);
      localStorage.removeItem(languageKey);
    } finally {
      resolve();
    }
  });
};

export const checkAndClearCacheIfLanguageChanged = async () => {
  const currentLanguage = window.freedomeConfig.locale;
  const cachedLanguage = localStorage.getItem(languageKey);

  if (cachedLanguage && cachedLanguage !== currentLanguage) {
    await clearListingDetailsCache();
    return true; // Cache was cleared
  }

  return false; // Cache was not cleared
};

export const invalidateCacheForLanguageChange = async () => {
  try {
    await clearListingDetailsCache();
    // console.log('Listing details cache cleared due to language change');
  } catch (error) {
    // console.error('Error clearing listing details cache:', error);
  }
};
